import { render, staticRenderFns } from "./couponActivityAdd.vue?vue&type=template&id=14c4b076&scoped=true&"
import script from "./couponActivityAdd.vue?vue&type=script&lang=js&"
export * from "./couponActivityAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c4b076",
  null
  
)

export default component.exports